// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bd5d85c9","455":"4d5a2b4b","488":"ea69d07c"}[chunkId] + ".chunk.js";
};